import React from 'react';
// @ts-ignore
import {
    Modal,
    ModalDialog,
    ModalContent,
    ModalHeader,
    ModalBody,
} from 'arag-ui-lib';
// @ts-ignore
import sanitizeHtml from 'sanitize-html';
type Props = {
    closeCommunicatorTemplate: () => any;
    communicatorTemplateOpen: boolean;
    log: {
        fileId: any;
        fileName: any;
        template: any;
        templateContent: any;
    };
};
const communicatorTemplateModal = (props: Props): JSX.Element => {
    const { closeCommunicatorTemplate, communicatorTemplateOpen, log } = props;
    return (
        <Modal
            fadeIn={communicatorTemplateOpen}
            darkenedBackground
            noScroll={true}
        >
            <ModalDialog>
                <ModalContent>
                    <ModalHeader onClose={closeCommunicatorTemplate} />
                    <ModalBody>
                        <div
                            style={{
                                paddingLeft: '20px',
                                paddingRight: '20px',
                                wordBreak: 'break-word',
                            }}
                            dangerouslySetInnerHTML={{
                                __html: sanitizeHtml(log.templateContent, {
                                    allowedTags:
                                        sanitizeHtml.defaults.allowedTags.concat(
                                            ['img'],
                                        ),
                                    allowedSchemes: ['data', 'http', 'https'],
                                    allowedAttributes: {
                                        '*': ['width', 'heigth'],
                                        img: ['src'],
                                        a: ['href', 'target'],
                                    },
                                }),
                            }}
                        />
                    </ModalBody>
                </ModalContent>
            </ModalDialog>
        </Modal>
    );
};

export default communicatorTemplateModal;
